import RegisterLink from "../../../components/RegisterLink";

const navLinks = [
  { label: "About Us" },
  { label: "Promotions & Bonuses" },
  { label: "Games" },
  { label: "Banking & Withdrawals" },
  { label: "Terms & Conditions" },
  { label: "Security" },
  { label: "Privacy Policy" },
  { label: "Responsible Gambling" },
  { label: "FAQs" },
];

const trustBadges = [
  { icon: "ri-shield-check-fill", label: "18+", color: "#f59e0b", bg: "rgba(245,158,11,0.15)", border: "rgba(245,158,11,0.3)" },
  { icon: "ri-verified-badge-fill", label: "Licensed", color: "#34d399", bg: "rgba(52,211,153,0.12)", border: "rgba(52,211,153,0.25)" },
  { icon: "ri-lock-fill", label: "SSL Secure", color: "#60a5fa", bg: "rgba(96,165,250,0.12)", border: "rgba(96,165,250,0.25)" },
  { icon: "ri-heart-fill", label: "Responsible Gaming", color: "#f472b6", bg: "rgba(244,114,182,0.12)", border: "rgba(244,114,182,0.25)" },
];

export default function Footer() {
  return (
    <footer
      className="relative pt-12 pb-8 mt-10"
      style={{
        background: "linear-gradient(180deg, rgba(8,30,102,0) 0%, rgba(4,10,60,0.95) 30%, #030a30 100%)",
        borderTop: "1px solid rgba(16,92,232,0.15)",
      }}
    >
      {/* Top glow line */}
      <div
        className="absolute top-0 left-0 right-0 h-px"
        style={{ background: "linear-gradient(90deg, transparent, rgba(16,92,232,0.4), rgba(224,201,127,0.2), transparent)" }}
      />

      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Brand */}
        <div className="text-center mb-8">
          <a href="/" className="inline-block" aria-label="Ace96au home">
            <img
              src="https://static.readdy.ai/image/b513b5b4a847779ee65de1525456761b/b8500fc5b880150736c6d516c60a553d.png"
              alt="ACE96AU"
              className="h-14 w-auto object-contain mx-auto"
            />
          </a>
        </div>

        {/* Nav Links */}
        <nav className="mb-8">
          <ul className="flex flex-wrap gap-6 justify-center">
            {navLinks.map((link) => (
              <li key={link.label}>
                <RegisterLink
                  trackLabel={`footer-${link.label}`}
                  className="text-slate-500 text-xs transition-colors tracking-wide hover:text-blue-400"
                >
                  {link.label}
                </RegisterLink>
              </li>
            ))}
          </ul>
        </nav>

        {/* Divider */}
        <div className="section-divider my-6" />

        {/* Trust Badges - Colorful */}
        <div className="flex flex-wrap items-center justify-center gap-4 mb-8">
          {trustBadges.map((b) => (
            <div
              key={b.label}
              className="flex items-center gap-2 px-4 py-2 rounded-xl transition-all duration-200 hover:scale-105 cursor-default"
              style={{
                background: b.bg,
                border: `1px solid ${b.border}`,
                backdropFilter: "blur(8px)",
              }}
            >
              <i className={`${b.icon} text-sm`} style={{ color: b.color }}></i>
              <span className="text-xs font-bold" style={{ color: b.color }}>{b.label}</span>
            </div>
          ))}
        </div>

        {/* Copyright */}
        <div
          className="pt-6 text-center"
          style={{ borderTop: "1px solid rgba(16,92,232,0.1)" }}
        >
          <p className="text-slate-700 text-xs">
            © 2026 Ace96au | All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
